import type { WorkflowRun } from '../../../../api/workflowRuns'
import { workflowRunProgressPercent } from '../../../../lib/workflow/workflowRunArtifacts'
import { workflowRunStatusLabel } from '../../../../lib/workflow/workflowRunDisplay'
import { ChromeToolbarButton } from '../../../ChromeActions'

type Props = {
  run: WorkflowRun
  angular: boolean
  onOpenRunPage?: () => void
}

/**
 * 工作流详情（灵动岛）：暂用轻量占位，步骤/时间线等待后续迭代。
 * @see docs/features/dynamic-island-detail.md
 */
export function DynamicIslandWorkflowDetailView({ run, angular: _angular, onOpenRunPage }: Props) {
  const progress = workflowRunProgressPercent(run)
  const statusLabel = workflowRunStatusLabel(run.status)
  const running = run.steps.find((step) => step.status === 'running')

  return (
    <div className="glyphicai-dynamic-island-detail-workflow flex h-full min-h-0 flex-col justify-center space-y-3">
      <div className="space-y-1">
        <p className="text-[10px] font-bold uppercase tracking-[0.08em] text-ink-soft">运行</p>
        <p className="font-mono text-xs text-ink">{run.publicId}</p>
      </div>
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="rounded-full bg-surface-muted/80 px-2 py-0.5 font-semibold text-ink shadow-[inset_0_0_0_1px_var(--line)]">
          {statusLabel}
        </span>
        {running ? (
          <span className="text-ink-soft">
            当前步骤：<span className="font-medium text-ink">{running.label}</span>
          </span>
        ) : null}
      </div>
      <div className="h-1 overflow-hidden rounded-full bg-line/35">
        <span
          className="block h-full rounded-full bg-accent transition-[width] duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
      {run.errorMessage ? (
        <p className="text-xs leading-snug text-red-600">{run.errorMessage}</p>
      ) : null}
      {onOpenRunPage ? (
        <div className="flex justify-end pt-1">
          <ChromeToolbarButton type="button" className="!text-xs" onClick={onOpenRunPage}>
            打开运行页
          </ChromeToolbarButton>
        </div>
      ) : null}
    </div>
  )
}
